import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { useTechExpCount } from '../../Hooks/Features/LeadDashboard/useTechExpCount';

const TechWiseTeamCount = () => {

    const { attributes, setViewYearly } = useTechExpCount();

    return (
        <div className='d-flex justify-content-center gap-2' style={{ height: "99%", width: "99%"}}>
            {attributes?.map((item) => (
                <div key={item?.title} className='card-container' style={{ width: item?.width }}>
                    <div className='d-flex justify-content-between'>
                        <div className={`mb-1 widget-title ${item?.show_btn ? "w50" : ""}`}>{item?.title}</div>
                        {item?.show_btn &&
                            <div>
                                <button className='button btn-default' onClick={() => setViewYearly(false)}>Last month</button>
                                <button className='button btn-default' onClick={() => setViewYearly(true)}>Yearly</button>
                            </div>
                        }
                    </div>
                    <div style={{ height: item?.height }}>
                        <HighchartsReact highcharts={Highcharts} options={item?.options} containerProps={{
                            style: {
                                height: "100%"
                            }
                        }} />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default TechWiseTeamCount